<template>
<div class="navbar-menu">
  <div class="navbar-end" v-if="loggedIn && !hideWallet && user">
    <div class="navbar-item">
      <div class="balance-item">
        <balance :title="this.$t('nav.wallet')" :symbol="getActiveToken" :amount="balance" to="/wallet" />
      </div>
    </div>
    <div class="navbar-item">
      <user-dropdown  />
    </div>
    <div class="navbar-item">
      <flag-dropdown />
    </div>
  </div>
  <div class="navbar-end" v-else>
    <div class="navbar-item" v-if="loggedIn && user">
      <user-dropdown />
    </div>
    <div class="navbar-item" v-if="login || signup">
      <span v-if="login">{{$t("nav.have-an-account")}}
        <router-link class="link" to="/login">{{$t('nav.login')}}</router-link>
      </span>
      <span v-else>{{$t("nav.dont-have-an-account")}}
        <router-link class="link" to="/signup">{{$t('nav.signup')}}</router-link>
      </span>
    </div>
    <div v-else-if="!user" class="navbar-item">
      <span>{{$t("nav.have-an-account")}}
        <router-link class="link" to="/login">{{$t('nav.login')}}</router-link>&nbsp;
      </span>
      <span>{{$t("nav.or-new-here")}}
        <router-link class="link" to="/signup">{{$t('nav.signup')}}</router-link>
      </span>
    </div>
    <div class="navbar-item">
      <flag-dropdown />
    </div>
  </div>
</div>
</template>

<script>
import Balance from '@/components/balance.vue'
import UserDropdown from '@/components/navbar/user-dropdown'
import FlagDropdown from '@/components/navbar/flag-dropdown'
import {mapGetters} from 'vuex'

export default {
  components: {
    Balance, UserDropdown, FlagDropdown
  },
  props: {
    login: {
      default: false
    },
    signup: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleDropdown () {
      this.showDropdown = !this.showDropdown
    }
  },
  computed: {
    ...mapGetters('users', [
      'user'
    ]),
    ...mapGetters('wallet', [
      'getActiveTokenBalance',
      'getActiveToken'
    ]),
    loggedIn () {
      return this.$route.meta.authType !== 'unauth'
    },
    hideWallet () {
      return this.$route.meta.hideWallet !== undefined
    },
    balance () {
      return this.getActiveTokenBalance ? this.getActiveTokenBalance.balance : 0
    }
  },
  data () {
    return {
      showDropdown: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.navbar-item {
  padding: 0.0rem 0.75rem;
  max-height: $navbar-height;
  display: flex;
  align-items: center;
}

@media screen and (max-width: $tablet) {
  .navbar-item {
    height: 60px;
  }
  .is-divider-vertical {
    display: inline-block;
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: auto;
    height: auto;
    padding: 2rem;
    margin: 0;
    position: relative;
    border-top: none;
    min-height: 2rem;
  }
  .is-divider-vertical::before {
    border-left: 0.1rem solid #dbdbdb;
    bottom: 1rem;
    content: "";
    display: inline-block;
    left: 50%;
    position: absolute;
    top: 1rem;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }
}

.balance-item {
  display: inline-block;
}

.link {
  font-weight: bold;
}

span {
  color: #111111;
}

</style>



// WEBPACK FOOTER //
// src/components/navbar/navbar-end.vue